import * as React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { ErrorMessage } from '@src/app/_global/components/error-messages/default-error-message';
import { IntelliselCarousel } from '@src/app/intellisel/components/IntelliselCarousel';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { INTELLISEL_TRANSACTION_CODES } from '@src/app/_global/utility/constants';
import './transfer.scss';
import ConfirmationDetail from '@src/app/_global/components/confirmation/ConfirmationDetail';
import { CustomCustomer, CustomOrder } from '@CDSGlobal/gc-backend';
interface ResponseViewProps {
  onExit: () => void;
  response: any;
  adminConfig: any;
  clientConfig: any;
  customer: CustomCustomer;
  oldProductName: string;
  newProductName: string;
  availableActions: any;
  currentOrder: CustomOrder;
}

const SuccessView: React.SFC<any> = props => {
  const { customer, oldProductName, newProductName} = props;
  let transferMessage = 'The last issue of ' + oldProductName + ' magazine will be ' + customer.lastIssueDescription + '.';
  return (
    <div>
      <div className="transfer-print">
        <button
          tabIndex={0}
          className="print-page icon-blue pointer fa fa-2x fa-print print-btn no-print"
          title="Print this page."
          onClick={() =>  window.print()}
        />
      </div>
      <div className="mb-2">
        <FormattedMessage
          id="transferconf.heading2"
          description="heading transferconf"
          defaultMessage="You have successfully transferred your subscription."
        />
      </div>
      <div className="transfer-text-current  mb-2">
        <span className="transfer-text">
          <FormattedMessage
            id="transferconf.product"
            description="product transferconf"
            defaultMessage="New Subscription: " 
          />
        </span>
        {newProductName}
      </div>
      <div className="mb-2 bold">
        <FormattedMessage
          id="transferconf.heading2"
          description="heading transferconf"
          defaultMessage={customer.lastIssueDescription ? transferMessage : ' '}
        />
      </div>
    </div>
  );
};

export const ResponseView: React.SFC<ResponseViewProps> = props => {
  const { response, onExit , adminConfig, clientConfig, customer, oldProductName, newProductName, availableActions, currentOrder } = props;

  const upsellOffers = getAdminConfigTableItem(
    adminConfig,
    clientConfig,
    'UpsellOffers',
    customer.prodIdAlias
  );
  let pageIntroTable = getAdminConfigTableItem(
    adminConfig,
    clientConfig,
    'PageIntro',
  );
  let pageIntro;
  if (pageIntroTable.PageIntroductions) {
    pageIntro = pageIntroTable.PageIntroductions.find(intro => {
      return intro.route === 'transfer';
    });
  }
  let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
  if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
    pageIntroDescHtml[0].innerHTML = pageIntro ? (pageIntro.confDescription ? pageIntro.confDescription : pageIntro.description ) : '';
  }
  let pageIntroLabelHtml = document.getElementsByClassName('page-intro-label') || null;
  if (pageIntroLabelHtml && pageIntroLabelHtml.length > 0) {
    pageIntroLabelHtml[0].innerHTML = pageIntro ? pageIntro.label + ' Confirmation' : '';
  }

  let pageHeader = document.getElementsByClassName('page-header') || null;
  if (pageIntro && pageIntro.hideLabel && pageHeader && pageHeader.length > 0) {
    let span = pageHeader[0].querySelector('span');
    if (span) {
      let defaultMessage = availableActions.Preferences.customTransferLabel ?
      availableActions.Preferences.customTransferLabel + ' Confirmation' : 'Transfer Subscription Confirmation';
      span.innerHTML = defaultMessage; 
    }
  }
  return (
    <div className="transfer-response-view">
      <Row>
        <Col xs={12} sm={12} md={12}>
          <div className="mt-4 mb-4">
            {response && response.success && <SuccessView customer={customer} oldProductName={oldProductName} newProductName={newProductName} />}
            {response && !response.success && <ErrorMessage onReset={onExit}/>}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={12}>
          {response && response.success && <ConfirmationDetail
            currentOrder={currentOrder}
            customer={customer}
            productDescription={'Previous Subscription:'}
          /> }
        </Col>
      </Row>
      <Container>
        {response && response.success && upsellOffers.UpsellEnabled && (
          <IntelliselCarousel 
            transactionCode={INTELLISEL_TRANSACTION_CODES.CANCEL_CONF}
          />
        )}
      </Container>
      <Row className="mt-auto">
        <Col xs={12} sm={12} md={12}>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={onExit}
            >
              <FormattedMessage
                id={'app.cancel'}
                description={'close button text'}
                defaultMessage={'Close'}
              />
            </button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
